(()=>{
  const template=document.getElementById('jd-cart-app-help');
  const source=document.getElementById('jd-cart-bundle-data');
  if(!template||!source)return;
  let bundles;try{bundles=JSON.parse(source.textContent);}catch{return;}
  let scheduled=false;
  function sync(){
    scheduled=false;
    const drawer=document.querySelector('.qsc2-drawer__content');
    if(!drawer)return;
    const header=drawer.querySelector('.qsc2-drawer-header');
    if(header&&!drawer.querySelector('.jd-cart-app-help'))header.after(template.content.cloneNode(true));
    const wrapping=drawer.querySelector('.qsc2-gift-wrapping');
    if(wrapping&&!wrapping.querySelector('.jd-cart-gift-note')){
      const note=document.createElement('p');note.className='jd-cart-app-line jd-cart-gift-note';
      note.textContent='Outer shipping box with Joeydolls tissue and tape; no separate keepsake box. Check bundle inclusions before adding another upgrade.';wrapping.append(note);
    }
    drawer.querySelectorAll('a[href*="/products/"]').forEach(link=>{
      let handle;try{handle=new URL(link.href,location.origin).pathname.split('/products/')[1];}catch{return;}
      const detail=bundles[handle];if(!detail||!link.textContent.trim())return;
      const container=link.parentElement;
      if(container.querySelector('.jd-cart-app-line'))return;
      const note=document.createElement('p');note.className='jd-cart-app-line';
      note.textContent='Per bundle: '+detail.contents+(detail.window?' '+detail.window:'');
      link.after(note);
    });
  }
  const observer=new MutationObserver(()=>{if(!scheduled){scheduled=true;requestAnimationFrame(sync);}});
  observer.observe(document.body,{childList:true,subtree:true});sync();
})();
